<template>
    <span>
        {{ checkLangCode(langCode) }}
    </span>
</template>

<script>
    export default {
        name: 'checkLangCode',
        props: ['langCode'],
        methods: {
            checkLangCode: function(lang) {
                return (this.$lang.langCode[lang]) ? this.$lang.langCode[lang] : this.$lang.langCode['unknown']
            },
        },
    }
</script>



// WEBPACK FOOTER //
// CheckLangCode.vue?6f9a62b0